var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.032 14L55.6281 36.7852H51.7224L47.4021 14H36.5979L32.2776 36.7852H28.3701L23.9662 14H12L16.8203 36.7852H12V49.2148H19.4786L24.2989 72H35.1032L39.9217 49.2148H44.0765L48.8968 72H59.7011L64.5196 49.2148H72V36.7852H67.1797L72 14H60.032Z",
    fill: "#E50914"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWLogo);
export default __webpack_public_path__ + "static/media/w-logo.6929b7bb671ca8cdfa82c6e48bd1e220.svg";
export { ForwardRef as ReactComponent };